<template>
  <v-dialog v-model="showDialog" scrollable persistent max-width="650" >
    <v-card>
      <v-card-title>
        <v-icon color="secondary">bluetooth</v-icon>
        <span>&ensp;</span>
        <span class="secondary--text">
          <strong>{{ beacon.name }}</strong>
        </span>
      </v-card-title>
      <v-card-text>
        <v-layout row>
          <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
            ID
          </v-flex>
          <v-flex xs9>
            <v-text-field v-model="beacon.id" class="pt-0" readonly/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
            {{ $t('items.owner') }}
          </v-flex>
          <v-flex xs9>
            <v-text-field v-model="beacon.client_name" class="pt-0" readonly/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
            {{ $t('items.is_mounted') }}
          </v-flex>
          <v-flex xs9>
            <v-radio-group :value="normalizedMounted" row class="mt-0" readonly>
              <v-radio :label="$t('items.mounted')" :value="true" />
              <v-radio :label="$t('items.movable')" :value="false" />
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
            {{ $t('items.name') }}
          </v-flex>
          <v-flex xs9>
            <v-text-field v-model="beacon.name" class="pt-0" readonly/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
            UUID
          </v-flex>
          <v-flex xs9>
            <v-text-field v-model="beacon.uuid" class="pt-0" readonly/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
            MAJOR / MINOR
          </v-flex>
          <v-flex xs4>
            <v-text-field v-model="beacon.major" class="pt-0" readonly/>
          </v-flex>
          <v-flex xs1>
          </v-flex>
          <v-flex xs4>
            <v-text-field v-model="beacon.minor" class="pt-0" readonly/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
            TX POWER
          </v-flex>
          <v-flex xs9>
            <v-text-field v-model="beacon.tx_power" class="pt-0" readonly/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
            LOCAL NAME
          </v-flex>
          <v-flex xs9>
            <v-text-field v-model="beacon.local_name" class="pt-0" readonly/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
            MODULE ID
          </v-flex>
          <v-flex xs9>
            <v-text-field v-model="beacon.module_id" class="pt-0" readonly/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
            MODEL
          </v-flex>
          <v-flex xs9>
            <v-btn
              color="primary"
              class="white--text"
            >
              <span>{{ beacon.model }}</span>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
            MANUFACTURER
          </v-flex>
          <v-flex xs9>
            <v-btn
              color="primary"
              class="white--text"
            >
              <span>{{ beacon.manufacturer }}</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn flat color="success" @click="onClose">
          {{ $t('common.ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const { normalizeMountedValue } = require("../../utils/clusterBeaconValidation");

export default {
  props: {
    beacon: { type: Object, required: true },
    value: { type: Boolean, default: false }
  },
  computed: {
    normalizedMounted() {
      return normalizeMountedValue(this.beacon.mounted);
    }
  },
  data() {
    return {
      showDialog: this.value
    };
  },
  watch: {
    value(val) {
      this.showDialog = val;
    },
    showDialog(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    onClose() {
      this.showDialog = false;
    }
  }
};
</script>
